// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__CbMyS","modalQuestionWrapper":"styles_modalQuestionWrapper__BqzMS","extraText":"styles_extraText__g-kCM"};